
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/note_v2/templates/upload_button"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='note-uploadIcon'></div>\n<div class='note-uploadLoader'></div>\n";
},"useData":true});
    }).call(this);
  